import request from "@/utils/request";
// import qs from "qs";

export function getUnReadMessageCount() {
  return request.get("/api/v3/column_hybrid/douyin/unread_message_count");
}

export function getMessageList(params) {
  return request.get("/api/v3/column_hybrid/douyin/message_list", { params });
}

export function messageSetread(params) {
  return request({
    url: `/api/v3/column_hybrid/douyin/message_setread`,
    method: "post",
    params,
  });
}

export function messageSetreadAll() {
  return request({
    url: `/api/v3/column_hybrid/douyin/message_setread_all`,
    method: "post",
  });
}
